import { render, staticRenderFns } from "./newComManagementSucceed.vue?vue&type=template&id=250aa2ca&scoped=true"
import script from "./newComManagementSucceed.vue?vue&type=script&lang=js"
export * from "./newComManagementSucceed.vue?vue&type=script&lang=js"
import style0 from "./newComManagementSucceed.vue?vue&type=style&index=0&id=250aa2ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250aa2ca",
  null
  
)

export default component.exports